import Icon from "@ant-design/icons";

const SVG = () => (
  <svg width="1em" height="1em" viewBox="0 0 24 24" fill="currentColor">
    <title></title>

    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 5.99902C15.3137 5.99902 18 8.68536 18 11.999C18 15.3127 15.3137 17.999 12 17.999C8.68629 17.999 6 15.3127 6 11.999C6.00005 8.68536 8.68632 5.99902 12 5.99902ZM12 8.24902C9.92896 8.24902 8.25005 9.928 8.25 11.999C8.25 14.0701 9.92893 15.749 12 15.749C14.0711 15.749 15.75 14.0701 15.75 11.999C15.75 9.928 14.071 8.24902 12 8.24902Z"
    />
  </svg>
);

const DotCircleEmpty = (props) => <Icon component={SVG} {...props} />;

export default DotCircleEmpty;
